import React from 'react'

import OnlineStatus from 'components/generic/OnlineStatus'
import {
  ListingCardLocationStatusContainer,
  LocationNameSpan,
  ListingCardLocationLayoutDiv,
} from './Styled'

const ListingCardLocationStatus = ({ locationName, lastOnline, listingPath }) => (
  <ListingCardLocationStatusContainer>
    <LocationNameSpan>{locationName}</LocationNameSpan>
    <ListingCardLocationLayoutDiv display={{ _: 'none', tablet: 'inline' }}>
      {lastOnline && (
        <>
          |<OnlineStatus lastOnline={lastOnline} listingPath={listingPath} />
        </>
      )}
    </ListingCardLocationLayoutDiv>
    <ListingCardLocationLayoutDiv display={{ _: 'flex', tablet: 'none' }}>
      {lastOnline && (
        <>
          <OnlineStatus lastOnline={lastOnline} listingPath={listingPath} />
        </>
      )}
    </ListingCardLocationLayoutDiv>
  </ListingCardLocationStatusContainer>
)

export default ListingCardLocationStatus
